import { decorate, action, computed, observable } from 'mobx'
import autoBind from "auto-bind"


class SheetsNamesUpdaterStore {
  errorMessage = ''
  iterations = 0
  loading = true
  submitting = false
  functionResponse = null
  fnTriggerCount = 0
  cannotSuggestNames = false
  existingSheets = {}
  sheetsNeedNameUpdate = {}
  sheetsGotNewName = {}

  constructor(appStore) {
    this.appStore = appStore;
    autoBind(this)
  }

  setErrorMessage(errorMessage) {
    this.errorMessage = errorMessage
  }

  setIterations(iterations) {
    this.iterations = iterations
  }

  setLoading(loading) {
    this.loading = loading
  }

  setSubmitting(submitting) {
    this.submitting = submitting
  }

  setFunctionResponse(functionResponse) {
    this.functionResponse = functionResponse
  }

  setFnTriggerCount(fnTriggerCount) {
    this.fnTriggerCount = fnTriggerCount
  }

  setCannotSuggestNames(cannotSuggestNames) {
    this.cannotSuggestNames = cannotSuggestNames
  }

  setExistingSheets(existingSheets) {
    this.existingSheets = existingSheets
  }

  setSheetsNeedNameUpdate(sheetsNeedNameUpdate) {
    this.sheetsNeedNameUpdate = sheetsNeedNameUpdate
  }

  setSheetsGotNewName(sheetsGotNewName) {
    this.sheetsGotNewName = sheetsGotNewName
  }

  addExistingSheets(existingSheets) {
    this.existingSheets = {
      ...this.existingSheets,
      ...existingSheets
    }
  }

  addSheetsGotNewName(sheetsGotNewName) {
    this.sheetsGotNewName = {
      ...this.sheetsGotNewName,
      ...sheetsGotNewName
    }
  }

  resetState() {
    this.errorMessage = ''
    this.iterations = 0
    this.loading = false
    this.submitting = false
    this.functionResponse = null
    this.fnTriggerCount = 0
    this.cannotSuggestNames = false
    this.existingSheets = {}
    this.sheetsNeedNameUpdate = {}
    this.sheetsGotNewName = {}
  }

}

decorate(SheetsNamesUpdaterStore, {
  errorMessage: observable,
  iterations: observable,
  loading: observable,
  submitting: observable,
  functionResponse: observable,
  fnTriggerCount: observable,
  cannotSuggestNames: observable,
  existingSheets: observable,
  sheetsNeedNameUpdate: observable,
  sheetsGotNewName: observable,

  addExistingSheets: action,
  addSheetsGotNewName: action,
  resetState: action,
  setCannotSuggestNames: action,
  setErrorMessage: action,
  setExistingSheets: action,
  setFnTriggerCount: action,
  setFunctionResponse: action,
  setIterations: action,
  setLoading: action,
  setSheetsGotNewName: action,
  setSheetsNeedNameUpdate: action,
  setSubmitting: action,
})

export default SheetsNamesUpdaterStore;